export const IFrameGameLoadedEventName = 'iFrameGameLoaded';
export const IFrameGameClickedEventName = 'iFrameGameClicked';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/iframe-game/_domain/models/events.ts